export default __webpack_public_path__ + "static/SELFLOVEALWAYS_GREEN-5d2e613d982e7ffd5fe39fd9e1b0d77b.png";